import React, { useEffect, useState } from 'react'
import { NavLink } from "react-router-dom";
import Button from '../Button';
import { checkSidebarStatus, walletConnectHandler } from '../../Utility/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { dark_mode, light_mode, set_admin, set_mode, set_sidebarStatus } from '../../Utility/constants';
import MenuIcon from '../../Assets/svg/menu.svg'
import DarkIcon from '../../Assets/svg/nightmode.svg'
import moonIcon from '../../Assets/svg/moon.svg'
import whiteMenuIcon from '../../Assets/svg/white_menu.svg'
import mainIcon from '../../Assets/svg/bg1.png'


import { ReactSVG } from 'react-svg'
import classNames from 'classnames'
import { SideBarList, SideBarListDark } from '../SideBar/SideBarList';
import OutsideClickHandler from 'react-outside-click-handler'
import DropDown from '../DropDown';
import metamaskIcon from '../../Styles/Assets/metamask-icon.png'
import { Bars } from 'react-loader-spinner';

const Header = (props) => {
    let dispatch = useDispatch()
    const from = useSelector(state => state.from)
    const status = useSelector(state => state.sidebarStatus)
    const balance = useSelector(state => state.balance)
    const networks = useSelector(state => state.networks)
    const mode = useSelector(state => state.mode)
    const splashLoading = useSelector(state => state.splashLoading)
    const swapLoading = useSelector(state => state.swapLoading)


    const [fromDropDown, setFromDropDown] = useState(false)
    const [acc, setAcc] = useState(false)

    const clickHandler = async () => {
        let acc = await walletConnectHandler()
        setAcc(acc)
        dispatch({ type: set_admin, payLoad: acc })
    }
    let userAcc = useSelector(state => {
        return state.acc
    })

    const [offset, setOffset] = useState(0);

    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => {
        if (window.ethereum && window.ethereum.selectedAddress) {
            dispatch({ type: set_admin, payLoad: window.ethereum.selectedAddress })
        }
    }, [])

    const modeChangeHandler = () => {
        if (mode === dark_mode) {
            dispatch({ type: set_mode, payLoad: light_mode })
            localStorage.setItem("mode", light_mode)
        } else {
            dispatch({ type: set_mode, payLoad: dark_mode })
            localStorage.setItem("mode", dark_mode)
        }
    }

    const navClass = classNames({
        nav_class: true,
        dark: mode === dark_mode ? true : false
    })

    const menuClass = classNames({
        menu_class: true,
        dark: mode === dark_mode ? true : false
    })

    const clickMenu = () => {
    }

    return (
        <div className='main_header' >
            <div className='container-fluid'>
                <div className='row align-items-center'>
                    <div className='col-2' >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img src={mainIcon} width="150px" height="100px" />
                     </div>
                    </div>
                    <div className='col-6'>
                        <ul className='menu_items'>
                            {
                                SideBarList.map((item, i) => (
                                    <li key={i}>
                                        <NavLink className={navClass} to={swapLoading ? "" : item.url}>{item.name}</NavLink>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                    <div className='col-4'>
                        <div className='left_header'>
                            <img onClick={() => !splashLoading ? null : clickHandler()} className='mobMetaMask' height={20} src={metamaskIcon}></img>
                            <ReactSVG className={menuClass} onClick={() => setFromDropDown(!fromDropDown)} src={mode === dark_mode ? whiteMenuIcon : MenuIcon} />
                            <img height={20} src={localStorage.getItem("from") ? networks[localStorage.getItem("from")]?.logo_url : networks[from]?.logo_url}></img>
                            <div style={{ display: window.innerWidth < 768 ? 'none' : 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                {from ?
                                    <p style={{ color: mode === dark_mode ? "#fff" : "#EE31AF", fontSize: 16, fontWeight: 'bold' }}>
                                        {balance == "" &&
                                            balance !== 0 ?
                                            <Bars className="bars_header" height="20" width="20" color={mode === dark_mode ? '#ffff' : "#fffff"}></Bars> :
                                            <>{localStorage.getItem("from") ? networks[localStorage.getItem("from")]?.token_name : networks[from]?.token_name} {Number(balance.toString().match(/^\d+(?:\.\d{0,5})?/))}</>}</p> :
                                    <Bars className="bars_header" height="20" width="20" color={mode === dark_mode ? '#ffff' : "#EE31AF"}></Bars>}
                                <div className='header_divider'>|</div>
                            </div>

                            {/* <img height={20} src={metamaskIcon}></img> */}
                            <p className='connect_wallet_text' style={{
                                color: mode === dark_mode ? "#fff" : "#fff", fontWeight: 600
                            }} onClick={() => !splashLoading ? null : clickHandler()}>{userAcc ? `${userAcc.slice(0, 6)}..${userAcc.slice(-6)}` : "Connect to Wallet"}</p>
                            
                            
                            {/* <ReactSVG onClick={modeChangeHandler} src={mode === dark_mode ? moonIcon : DarkIcon} /> */}

                        </div>
                        <OutsideClickHandler onOutsideClick={() => { setFromDropDown(false) }}>
                            <div onClick={(e) => {
                                setFromDropDown(!fromDropDown)
                            }} >
                                <DropDown page={true} change={(val) => { }} display={fromDropDown} items={mode === dark_mode ? SideBarListDark : SideBarList} />

                            </div>
                        </OutsideClickHandler>
                    </div>
                </div>
            </div>
        </div >

    )
}


export default Header